import styles from "./ProgressBar.module.scss";

type ProgressBarProps = {
  stepsCount: number;
  activeStepNr: number;
};

export const ProgressBar = ({stepsCount, activeStepNr}: ProgressBarProps) => {
  const progressWidth = (activeStepNr / (stepsCount - 1)) * 100 + "%";
  return (
    <div className={styles.progressBar}>
      <div className={styles.progress} style={{width: progressWidth}}></div>
      {Array.from({length: stepsCount}, (_, index) => (
        <div key={index} className={`${styles.circle} ${index <= activeStepNr ? styles.active : ""}`}></div>
      ))}
    </div>
  );
};
